import React from "react";
import "../../components/PetTypeList/PetTypeList.css";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";


const PetTypeList = ({petTypeDetailResponse, setOpenProfile, openProfile,GetId,openAddProfile,setOpenAddProfile}) => {
    //console.log(petTypeDetailResponse);
    function HandleChange(param) {
    
      GetId(param);
    }
  return (
    <div className="container-fluid">
      
      <div className="PetTypeList">
        <table>
          <tr className="PetTypeListHeading">
            <th>ID</th>
            <th>Pet Type</th>
            <th>Status</th>
            <th>Details</th>
          </tr>
          {petTypeDetailResponse !== null ? (
    petTypeDetailResponse.map((petType) => (
        <tr key={petType.id}>
            <td>{petType.id}</td>
            <td>{petType.petType}</td>
            <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
                <button style={{ height: "30px", width: "38px" }} onClick={() => {
                  setOpenProfile(!openProfile);
                  HandleChange(petType.id);
                  setOpenAddProfile(false); 
                  }}>
                    <SearchIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)}
         
          
        </table>
      </div>
    </div>
  );
};

export default PetTypeList;
